
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.575 7.406H1.23a.703.703 0 00-.703.704v7.03c0 .39.315.704.703.704h2.344a.703.703 0 00.703-.703V8.11a.703.703 0 00-.703-.704zm-1.172 7.266a.703.703 0 110-1.406.703.703 0 010 1.406zM11.778 3.23c0 1.243-.761 1.94-.975 2.77h2.98c.979 0 1.74.813 1.745 1.702.002.526-.221 1.092-.57 1.442l-.003.003c.288.684.241 1.642-.273 2.328.255.759-.002 1.69-.48 2.19.126.516.066.955-.18 1.308-.598.859-2.08.87-3.333.87h-.083c-1.415 0-2.573-.515-3.503-.928-.467-.208-1.079-.466-1.542-.474a.352.352 0 01-.346-.352V7.826c0-.094.038-.184.105-.25 1.16-1.146 1.66-2.36 2.61-3.313.434-.435.592-1.091.744-1.726.13-.542.403-1.693.994-1.693.704 0 2.11.234 2.11 2.386z","fill":"#8A94A6"}})])
          )
        }
      }
    